import { render, staticRenderFns } from "./LikeHeart.vue?vue&type=template&id=c26aa1f8&scoped=true&"
import script from "./LikeHeart.vue?vue&type=script&lang=js&"
export * from "./LikeHeart.vue?vue&type=script&lang=js&"
import style0 from "./LikeHeart.vue?vue&type=style&index=0&id=c26aa1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26aa1f8",
  null
  
)

export default component.exports